import React, { Component } from 'react'
import { Swiper, Slide } from 'react-dynamic-swiper'
import { map } from 'lodash'
import uuidv1 from 'uuid/v1'
import 'react-dynamic-swiper/lib/styles.css'

import StudentLink from '../Peers/StudentLink'
import Refresh from './Refresh'

import {
  Loading,
  SliderWrapper,
  PlaceholderWrapper,
  Placeholder,
  ImageTest,
  Wrap,
  Caption,
  CaptionItem,
  Underline,
  RelativeWrapper,
  CaptionWrapper,
} from './styles'

const arrowIcon = `
<svg width="33px" height="22px" viewBox="0 0 33 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->
<desc>Created with Sketch.</desc>
<defs></defs>
<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="6" transform="translate(-1305.000000, -798.000000)" fill="#0047BB">
        <g id="Group-6" transform="translate(1065.000000, 773.000000)">
            <polygon id="→" points="258.7 25.58 268.42 35.165 240.25 35.165 240.25 37.415 268.375 37.415 258.7 47 262.075 47 272.74 36.29 262.075 25.58"></polygon>
        </g>
    </g>
</g>
</svg>`

class SlideTest extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
    this.isLoaded = this.isLoaded.bind(this)
    this.progressBackup = this.progressBackup.bind(this)
  }

  isLoaded() {
    console.log('is loaded')
    this.setState({ loading: false })
  }

  progressBackup() {
    if (!this.state.loading) return
    this.reactSwiper.swiper().updateSlides()
    this.setState({ loading: false })
  }

  render() {
    const { collection, ready } = this.props
    const { loading } = this.state

    console.log(ready)

    return (
      <Wrap loading={loading}>
        <PlaceholderWrapper loading={loading}>
          <div />
          <div />
          <div />
        </PlaceholderWrapper>
        <Loading loading={loading} className="flex loading">
          loading...
        </Loading>
        {ready && (
          <SliderWrapper loading={loading}>
            <Swiper
              ref={(ref) => {
                this.reactSwiper = ref
              }}
              swiperOptions={{
                slidesPerView: 'auto',
                centeredSlides: true,
                centerInsufficientSlides: true,
                updateOnImagesReady: true,
                spaceBetween: 30,
                initialSlide: 1,
                preloadImages: true,
                autoplay: {
                  delay: 3500,
                  disableOnInteraction: false,
                },
                loop: false,
                grabCursor: true,
              }}
              navigation
              pagination={false}
              progress={() => this.progressBackup()}
              imagesReady={() => this.isLoaded()}
            >
              {map(collection, (item, iter) => (
                <Slide key={item.id}>
                  <RelativeWrapper>
                    <ImageTest
                      ar={item.image.width / item.image.height}
                      srcSet={`${item.image.url}?w=240${
                        iter === collection.length - 1 ? `&${uuidv1()}` : ''
                      } 240w,
                    ${item.image.url}?w=480${
                        iter === collection.length - 1 ? `&${uuidv1()}` : ''
                      } 480w,
                    ${item.image.url}?w=720${
                        iter === collection.length - 1 ? `&${uuidv1()}` : ''
                      } 720w,
                    ${item.image.url}?w=960${
                        iter === collection.length - 1 ? `&${uuidv1()}` : ''
                      } 960w,
                    ${item.image.url}?w=1440${
                        iter === collection.length - 1 ? `&${uuidv1()}` : ''
                      } 1440w,
                    ${item.image.url}?w=1920${
                        iter === collection.length - 1 ? `&${uuidv1()}` : ''
                      } 1920w`}
                      sizes="66vw"
                      src={`${item.image.url}?w=1000${
                        iter === collection.length - 1 ? `&${uuidv1()}` : ''
                      }`}
                      title={item.title}
                      alt={item.alt || item.title}
                    />
                    <CaptionWrapper>
                      {item.studentName && item.studentId && (
                        <StudentLink hasDetail id={item.studentId}>
                          <Underline>{item.studentName}</Underline>
                        </StudentLink>
                      )}
                      {item.title && <p>{item.title}</p>}
                    </CaptionWrapper>
                  </RelativeWrapper>
                </Slide>
              ))}
            </Swiper>
            {/* <Refresh prefix="refresh-art" /> */}
          </SliderWrapper>
        )}
      </Wrap>
    )
  }
}

export default SlideTest
